import { WrappedFormUtils } from 'antd/lib/form/Form'
import { FieldNames } from 'Constants/FieldNames'
import { isEmptyValue } from 'Helpers'

export const formErrorState = (form: WrappedFormUtils, fieldNames?: string[]): boolean => {
	const fieldsError = form?.getFieldsError(fieldNames)
	return Object.keys(fieldsError).some((field): boolean => Boolean(fieldsError[field]))
}

export const getFieldsErrorOnly = (form: WrappedFormUtils): Record<FieldNames, unknown> | null => {
	const formErrors = form?.getFieldsError()
	return formErrors
		? Object.keys(formErrors).reduce((acc, field): Record<FieldNames, unknown> => {
				if (formErrors[field] !== undefined) acc[field] = formErrors[field]
				return acc
		  }, {} as Record<FieldNames, unknown>)
		: null
}

export const onlyRequiredErrorState = (form: WrappedFormUtils): boolean => {
	const fieldsError = form?.getFieldsError()
	const fieldsValue = form?.getFieldsValue()
	return Object.keys(fieldsError).some(
		(field): boolean => fieldsError[field] && !isEmptyValue(fieldsValue[field])
	)
}

export const checkRequiredFields = (
	form: WrappedFormUtils,
	requiredFields?: FieldNames[]
): boolean => {
	const fields = requiredFields ?? Object.keys(form.getFieldsValue())
	for (let i = 0; i < fields.length; i += 1) {
		if (isEmptyValue(form.getFieldValue(fields[i]))) return false
	}
	return true
}
